var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{ref:"dialog"},[_c('div',[_c('div',[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/e7c3a99e2a9e31c335a43991142095e4.jpg","alt":""},on:{"click":_vm.goAppoint}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }